<div
  class="fup-zone"
  [class.fup-zone--dragging]="isDragging() && !disabled()"
  [class.fup-zone--disabled]="disabled()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <input
    type="file"
    #fileInput
    hidden
    [accept]="acceptedFileTypes().join(',')"
    (change)="onFileSelected($event)"
  />

  @if (!selectedFile()) {
    <div class="fup-empty">
      <div class="fup-empty__icon-wrap">
        <i class="pi pi-cloud-upload fup-empty__icon"></i>
      </div>
      <p class="fup-empty__title">{{ 'upload_document' | transloco }}</p>
      <p class="fup-empty__hint">
        {{ 'max_file_size' | transloco }} {{ maxFileSizeMB() }} {{ 'mb' | transloco }}
      </p>
      <button class="fup-choose-btn" type="button" (click)="fileInput.click()">
        <i class="pi pi-folder-open"></i>
        {{ 'choose_file' | transloco }}
      </button>
    </div>
  } @else {
    <div class="fup-preview-wrap">
      <div class="fup-file-badge">
        <div class="fup-file-badge__info">
          <span class="fup-file-badge__icon-wrap">
            <i class="pi pi-file"></i>
          </span>
          <div class="fup-file-badge__meta">
            <span class="fup-file-badge__name" [title]="selectedFile()?.name">
              {{ selectedFile()?.name }}
            </span>
            <span class="fup-file-badge__size">{{ formatBytes(selectedFile()?.size || 0) }}</span>
          </div>
        </div>
        <button class="fup-file-badge__remove" type="button" (click)="removeFile()" aria-label="Remove file">
          <i class="pi pi-times"></i>
        </button>
      </div>

      @if (showPreview()) {
        @if (isImageFile()) {
          <img
            [src]="filePreviewUrl()"
            [alt]="selectedFile()?.name"
            class="fup-preview-img"
          />
        } @else if (isPdfFile()) {
          <lib-app-pdf-viewer
            [pdfSource]="filePreviewUrl()"
            height="80vh"
            customClass="w-full rounded-lg shadow-lg"
          />
        } @else {
          <div class="fup-unsupported">
            <i class="pi pi-file fup-unsupported__icon"></i>
            <span class="fup-unsupported__name">{{ selectedFile()?.name }}</span>
          </div>
        }
      }
    </div>
  }

  @if (errorMessage()) {
    <div class="fup-error">
      <i class="pi pi-exclamation-circle fup-error__icon"></i>
      <span class="fup-error__text">{{ errorMessage() }}</span>
    </div>
  }
</div>
